import React, { useEffect, useState } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import {
  calcDisplayNo,
  extractAllStudents,
  extractMatricDigits,
} from "../../AppManager";
import MemberCard from "../../components/MemberCard";
import EmptySearch from "../../components/EmptySearch";
import Filter from "../../components/Filter";
import Pagination from "../../components/Pagination";

export function StudentsLoader() {
  return (
    <>
      <div
        className="loader-item"
        style={{
          width: "150px",
          height: "200px",
          background: "linear-gradient(to top right, #F4F6FF 0%, #FFF 100%)",
          backgroundSize: "200% 100%",
          boxShadow: "0 5px 8px rgba(0, 0, 0, 0.4)",
          borderRadius: "5px",
          margin: "10px 5px",
        }}
      ></div>
      <div
        className="loader-item"
        style={{
          width: "150px",
          height: "200px",
          background: "linear-gradient(to top right, #F4F6FF 0%, #FFF 100%)",
          backgroundSize: "200% 100%",
          boxShadow: "0 5px 8px rgba(0, 0, 0, 0.4)",
          borderRadius: "5px",
          margin: "10px 5px",
        }}
      ></div>
      <div
        className="loader-item"
        style={{
          width: "150px",
          height: "200px",
          background: "linear-gradient(to top right, #F4F6FF 0%, #FFF 100%)",
          backgroundSize: "200% 100%",
          boxShadow: "0 5px 8px rgba(0, 0, 0, 0.4)",
          borderRadius: "5px",
          margin: "10px 5px",
        }}
      ></div>
    </>
  );
}

function AllStudents() {
  const { search, record, setShowSearch } = useOutletContext();
  const [store, setStore] = useState([]);
  const [students, setStudents] = useState([]);
  const [studentsFetch, setStudentsFetch] = useState(false);
  const [searchParams] = useSearchParams();
  const classFilter = searchParams.get("trainingClass");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    let page = searchParams.get("page") || 1;
    page = parseInt(page);
    page = page > 0 ? page : 1;

    let limit = searchParams.get("limit") || 10;
    limit = parseInt(limit);
    limit = limit > 0 ? limit : 10;
    setPagination({ page, limit });
  }, [searchParams]);

  useEffect(() => {
    const width = 160;
    const height = 220;
    const pagePadMarginWidth = 20;
    const pagePadMarginHeight = 20;
    setPagination((old) => ({
      ...old,
      limit: calcDisplayNo(
        width,
        height,
        pagePadMarginWidth,
        pagePadMarginHeight
      ),
    }));
    window.addEventListener("resize", () => {
      setPagination((old) => ({
        ...old,
        limit: calcDisplayNo(
          width,
          height,
          pagePadMarginWidth,
          pagePadMarginHeight
        ),
      }));
    });

    return () => {
      window.removeEventListener("resize", () => {
        setPagination((old) => ({
          ...old,
          limit: calcDisplayNo(
            width,
            height,
            pagePadMarginWidth,
            pagePadMarginHeight
          ),
        }));
      });
    };
  }, []);

  useEffect(() => {
    setStudentsFetch(false);
    extractAllStudents(record)
      .then((data) => {
        setStore(data);
        setStudentsFetch(true);
      })
      .catch((err) => err);
  }, [record]);

  useEffect(() => {
    let data = store;
    if (classFilter)
      data = data.filter((dat) => dat.trainingClass === classFilter);
    data = data.filter(
      (dat) =>
        dat.name.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        dat.matric.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        dat.class.toLowerCase().indexOf(search.toLowerCase()) > -1
    );

    setStudents(data);
  }, [store, classFilter, search]);

  useEffect(() => {
    setShowSearch(true);
  });

  document.title = "All Students";

  const { page, limit } = pagination;
  const start = (page - 1) * limit;
  const end = start + limit;

  const studentsElement = students
    .slice(start, end)
    .map((dat) => (
      <MemberCard
        key={dat.matric}
        name={dat.name}
        image={dat.image}
        matric={dat.matric}
        to={extractMatricDigits(dat.matric)}
        imgfolder="students"
      />
    ));

  return (
    <div className="overview-students">
      <h1 className="heading1" style={{ width: "100vw" }}>
        All Students
      </h1>
      {students.length !== 0 && <Filter classFilter={classFilter} />}
      {studentsFetch ? (
        studentsElement.length === 0 ? (
          <EmptySearch message={"No Student Found"} />
        ) : (
          <>
            {studentsElement}
            <Pagination
              limit={pagination.limit}
              currentPage={pagination.page}
              totalPages={Math.ceil(students.length / pagination.limit)}
            />
          </>
        )
      ) : (
        <StudentsLoader />
      )}
    </div>
  );
}

export default AllStudents;
